import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CONTAINERS } from '../data/containers';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  bucket = 2.4;
  sausage = 0.6; // opakowanie potocznie nazywane "kiełbasą"
  tin = 0.75;
  tape = 1;

  constructor(
    private apiService: ApiService
  ) { }

  print(storage) {
    this.setPackagesSizes(storage);

    const data = {
      storage: null,
      system: null,
      usage_windows: {},
      usage_total: {},
      packages: {}
    };
    data.storage = storage;
    data.system = storage.systemType;
    const usage = this.getUsageForWindows(storage.windows);
    data.usage_windows = usage.window;
    data.usage_total = usage.total;
    data.packages = this.calculatePackages(usage.total);


    this.apiService.print(data);

  }
  setPackagesSizes(storage) {
    const container = this.getContainerBySystemId(storage.systemType);

    if (container) {
      this.bucket = container.usage.bucket;
      this.sausage = container.usage.sausage;
      this.tin = container.usage.tin;
      this.tape = container.usage.tape;
    }
  }

  private getContainerBySystemId(id) {
    for (const container of CONTAINERS) {
      if (container.sys_id === id) {
        return container;
      }
    }
    return null;
  }

  calculatePackages(usage) {
    const insideLiquidFoilConsumptionBucketCount = Math.ceil(usage.foilInside / this.bucket);

    const insideLiquidFoilConsumptionSausageCount = Math.ceil(usage.foilInside / this.sausage);

    const outsideLiquidFoilConsumptionBucketCount = Math.ceil(usage.foilOutside / this.bucket);

    const outsideLiquidFoilConsumptionSausageCount = Math.ceil(usage.foilOutside / this.sausage);

    const flexConsumptionTin = Math.ceil(usage.foam / this.tin);
    const tapeConsumption = Math.ceil(usage.tape / this.tape);

    const packages = {
      foilInsideBucket: insideLiquidFoilConsumptionBucketCount,
      foilInsideSausage: insideLiquidFoilConsumptionSausageCount,
      foilOutsideBucket: outsideLiquidFoilConsumptionBucketCount,
      foilOutsideSausage: outsideLiquidFoilConsumptionSausageCount,
      foam: flexConsumptionTin,
      tape: tapeConsumption
    };

    return packages;
  }

  getUsageForWindows(windows) {

    const usagePerWindow = {};
    let totalUsage = {};
    let usage = {total: null, window: null};
    let insideLiquidFoilConsumption = 0;
    let flexConsumption = 0;
    let outsideWindowLength = 0;
    let outsideLiquidFoilConsumption = 0;
    _.forEach(windows, window => {
      if (window.type === 'STANDARD') {
        const isSameDepth = window.standard.isSameDepth;
        const windowDepth = window.standard.depth;

        let windowInsideLiquidFoilConsumption = 0;
        let windowFlexConsumption = 0;
        _.forEach(window.standard.inside.edges, edge => {
          const depth = isSameDepth ? windowDepth : edge.depth;
          windowInsideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
          windowFlexConsumption += ((edge.width) / 100) * ((depth) / 100) * edge.length / 100;

        });

        insideLiquidFoilConsumption += windowInsideLiquidFoilConsumption * window.amount;
        flexConsumption += windowFlexConsumption * window.amount;

        let windowOutsideLiquidFoilConsumption = 0;
        let windowOutsideWindowLength = 0;
        _.forEach(window.standard.outside.edges, edge => {
          const depth = isSameDepth ? windowDepth : edge.depth;
          windowOutsideWindowLength += edge.length / 1000;
          windowOutsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
        });

        outsideWindowLength += windowOutsideWindowLength * window.amount;
        outsideLiquidFoilConsumption += windowOutsideLiquidFoilConsumption * window.amount;

        usagePerWindow[window.id] = {
          foam: windowFlexConsumption.toFixed(2),
          foilInside: windowInsideLiquidFoilConsumption.toFixed(2),
          foilOutside: windowOutsideLiquidFoilConsumption.toFixed(2),
          tape: windowOutsideWindowLength.toFixed(2)
        };

      } else if (window.type === 'NONSTANDARD') {

        let windowInsideLiquidFoilConsumption = 0;
        let windowFlexConsumption = 0;
        _.forEach(window.nonstandard.inside.edges, edge => {
          windowInsideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
          windowFlexConsumption += ((edge.width) / 100) * ((edge.depth) / 100) * edge.length / 100;
        });

        insideLiquidFoilConsumption += windowInsideLiquidFoilConsumption * window.amount;
        flexConsumption += windowFlexConsumption * window.amount;

        let windowOutsideLiquidFoilConsumption = 0;
        let windowOutsideWindowLength = 0;
        _.forEach(window.nonstandard.outside.edges, edge => {
          windowOutsideWindowLength += edge.length / 1000;
          windowOutsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
        });
        outsideWindowLength += windowOutsideWindowLength * window.amount;
        outsideLiquidFoilConsumption += windowOutsideLiquidFoilConsumption * window.amount;

        usagePerWindow[window.id] = {
          foam: windowFlexConsumption.toFixed(2),
          foilInside: windowInsideLiquidFoilConsumption.toFixed(2),
          foilOutside: windowOutsideLiquidFoilConsumption.toFixed(2),
          tape: windowOutsideWindowLength.toFixed(2)
        };
      }

    });

    totalUsage = {
      foam: flexConsumption.toFixed(2),
      foilInside: insideLiquidFoilConsumption.toFixed(2),
      foilOutside: outsideLiquidFoilConsumption.toFixed(2),
      tape: outsideWindowLength.toFixed(2)
    };
    usage = {
      total: totalUsage,
      window: usagePerWindow
    };
    return usage;
  }

  getUsageForWindow() {

  }

}
